export default (value) => {
  return value === undefined
}



// WEBPACK FOOTER //
// ./node_modules/vue-fraction-grid/utils/is-undefined.js